const routes = [
  {
    path:      '/citasporestado',
    name:      'CitasPorEstado',
    component: () => import('@/views/dashboards/citas/CitasPorEstado.vue'),
    meta: { title: 'Por estado',       categoria: 'Citas', icono: 'circle-check' }
  },
  {
    path:      '/citasporespecialidad',
    name:      'CitasPorEspecialidad',
    component: () => import('@/views/dashboards/citas/CitasPorEspecialidad.vue'),
    meta: { title: 'Por especialidad', categoria: 'Citas', icono: 'stethoscope' }
  },
  {
    path:      '/citaspormedico',
    name:      'CitasPorMedico',
    component: () => import('@/views/dashboards/citas/CitasPorMedico.vue'),
    meta: { title: 'Por médico',       categoria: 'Citas', icono: 'person_check' }
  },
  {
    path:      '/citaspormotivo',
    name:      'CitasPorMotivo',
    component: () => import('@/views/dashboards/citas/CitasPorMotivo.vue'),
    meta: { title: 'Por motivo',       categoria: 'Citas', icono: 'message' }
  },
  {
    path:      '/citasporhoradia',
    name:      'CitasPorHoraDia',
    component: () => import('@/views/dashboards/citas/CitasPorHoraDia.vue'),
    meta: { title: 'Por hora / día',   categoria: 'Citas', icono: 'clock', nuevo: true }
  },
]

export { routes }